/** Title-case words (outcome / status labels). */
export function capitalizeStatusLabel(text) {
    if (text == null || text === '' || text === '—') return text;
    const s = String(text).trim();
    if (!s) return '—';
    return s.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
}

/** Outcome column: normalized display with capitalized words. */
export function formatOutcomeStatus(status) {
    if (status == null || status === '') return capitalizeStatusLabel('Pending');
    return capitalizeStatusLabel(status);
}

/** Labels for outbound_customers.call_group_member_status */
export function formatCallGroupMemberStatus(status) {
    if (status == null || status === '') return '—';
    const map = {
        pending: 'Pending',
        dialing: 'Dialing',
        done_no_answer: 'No answer',
        done_answered: 'Answered',
        answered: 'Answered',
        skipped: 'Skipped',
        no_answer: 'No answer',
    };
    const raw = map[status] || String(status).replace(/_/g, ' ');
    return raw === '—' ? raw : capitalizeStatusLabel(raw);
}

/** Priority / Required columns — API may send 0/false; avoid falsy bugs in JSX. */
export function formatCallGroupPriorityCell(customer) {
    const p = customer?.call_group_priority;
    if (p === undefined || p === null) return '—';
    return String(p);
}

export function formatCallGroupRequiredCell(customer) {
    const v = customer?.call_group_required;
    if (v === true || v === 1 || v === '1') return 'Yes';
    if (v === false || v === 0 || v === '0') return 'No';
    return '—';
}

export function formatCallGroupNameCell(customer) {
    const n = customer?.call_group_name;
    if (n == null || String(n).trim() === '') return '—';
    return String(n);
}

/** Escalation column color (skipped = mustard yellow). */
export function callGroupEscalationColor(memberStatus) {
    const s = memberStatus;
    if (s === 'done_answered' || s === 'answered') return '#21ba45';
    if (s === 'dialing') return '#0d6efd';
    if (s === 'done_no_answer' || s === 'no_answer') return '#dc3545';
    if (s === 'skipped') return '#b8860b';
    return '#6c757d';
}
